/**
 * Device Configuration Types
 *
 * Type definitions for device/platform-specific configuration.
 */

export const PLATFORMS = {
  ANDROID: 'ANDROID',
  IOS: 'IOS',
  WEB: 'WEB',
} as const;

export type Platform = (typeof PLATFORMS)[keyof typeof PLATFORMS];

/**
 * No `configurationOverride` here on purpose. V1 reads its override from this
 * object (web/src/configuration/configureStore.js:34); V2 reads its own from the
 * init config, as `InitConfiguration.configurationOverride`. Declaring it on both
 * would promise a mobile SDK an override that V2 never reads.
 */
export interface DeviceConfig {
  deviceId?: string;
  deviceManufacturer?: string;
  deviceModel?: string;
  iframeParentUrl?: string;
  isIframe?: boolean;
  os?: string;
  osVersion?: string;
  platform: Platform;
  sdkVersion?: string;
  storedState?: Record<string, unknown>;
}
